import { render, staticRenderFns } from "./CreateManualOrder.vue?vue&type=template&id=0f662b13"
import script from "./CreateManualOrder.vue?vue&type=script&lang=js"
export * from "./CreateManualOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports